// src/App.tsx
// Updated: 2026-08-20 15:00:00 CDT
// Purpose: Public TableRead.tv routing, including secure password management.

import React from "react";
import {
  Route,
  Routes,
} from "react-router-dom";
import {
  Helmet,
  HelmetProvider,
} from "react-helmet-async";

import Index from "@/pages/Index";
import AccountSettings from "@/pages/AccountSettings";
import ForgotPassword from "@/pages/ForgotPassword";
import NotFound from "@/pages/NotFound";
import ResetPassword from "@/pages/ResetPassword";
import ProtectedRoute from "@/auth/ProtectedRoute";
import { InterfaceTextSizeProvider } from '@/contexts/InterfaceTextSize';
import { ModifierDisplayProvider } from '@/contexts/ModifierDisplay';

const App: React.FC = () => {
  return (
    <InterfaceTextSizeProvider><ModifierDisplayProvider><HelmetProvider>
      <Helmet>
        <title>TableRead.tv</title>
        <meta
          name="description"
          content="Turn your screenplays into lifelike audio with AI voices."
        />
        <meta
          name="robots"
          content="index,follow"
        />
      </Helmet>

      <Routes>
        <Route
          path="/"
          element={<Index />}
        />
        <Route
          path="/login"
          element={<Index />}
        />
        <Route
          path="/forgot-password"
          element={<ForgotPassword />}
        />
        <Route
          path="/reset-password"
          element={<ResetPassword />}
        />
        <Route element={<ProtectedRoute />}>
          <Route
            path="/account"
            element={<AccountSettings />}
          />
        </Route>
        <Route
          path="*"
          element={<NotFound />}
        />
      </Routes>
    </HelmetProvider></ModifierDisplayProvider></InterfaceTextSizeProvider>
  );
};

export default App;
